module.exports = __webpack_public_path__ + "static/bracers_of_archery-2edcea88fc8c8608ee9dcb5e6e3cf127.jpeg";